module.exports = __webpack_public_path__ + "static/media/arrow-up.84cc97c5.svg";